import { React, useState, useEffect, useContext, useRef, useCallback } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, FilesAPIConstants, ClaimApprovalConstants, ClaimStatusConstants, CommonAPIConstants, PostingpaymentsConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { setUser } from '../redux/actions/userActions'
import { Link, json } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parse } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import DebouncedInput from '../common/hook/DebouncedInput'
import { exportExcel } from '../utilities/exportToExcel'


const PostingPayments = () => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');



    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(defaultFromDate); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);


    const ServiceLocValues = [
        { TextField: 'Office - 11', ValueField: '11' },
        { TextField: 'Home - 12', ValueField: '12' },
        { TextField: 'SUD - 57', ValueField: '57' },
        { TextField: 'Lab - 81', ValueField: '81' },


    ];

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState('');

    const [searchPatientText, setSearchPatientText] = useState('');
    const [searchProvidersText, setSearchProvidersText] = useState('');
    const [searchInsuranceText, setSearchInsuranceText] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
    const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
    const [sPatID, setSPatID] = useState('');
    const [sInsID, setSInsID] = useState('');
    const [sClaimStatus, setsClaimStatus] = useState('');
    const [rowsValidation, setRowsValidation] = useState('');
    const [isChecked, setIsChecked] = useState(false);



    const [tableDetails, setTableDetails] = useState([]);
    const [tableInsDetails, setTableInsDetails] = useState([]);
    const [checkEligibility, setCheckEligibility] = useState([]);
    const [selectedClaims, setSelectedClaims] = useState([]);
    const [selectAllDropdown, setSelectAllDropdown] = useState([]);
    const [checkboxes, setCheckboxes] = useState();

    const [searchPatientData, setSearchPatientData] = useState([]);
    const [suggestionProviders, setSuggestionProviders] = useState('');
    const [suggestionInsurance, setSuggestionInsurance] = useState('');
    const [patientList, setPatientList] = useState('');




    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedSendRows, setSelectedSendRows] = useState([]);
    const [selectedLocationRows, setSelectedLocationRows] = useState([]);
    const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
    const [UnitChargeRows, setUnitChargeRows] = useState([]);
    const [unitCheckbox, setUnitCheckbox] = useState([]);
    const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
    const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
    const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
    const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
    const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
    const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
    const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
    const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
    const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] = useState([]);


    const [searchByPatient, setSearchByPatient] = useState('');
    const [searchByDOB, setSearchByDOB] = useState('');
    const [searchByInsurance, setSearchByInsurance] = useState('');
    const [searchByProvider, setSearchByProvider] = useState('');
    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByDOS, setSearchByDOS] = useState('');
    const [searchByPostingDate, setSearchByPostingDate] = useState('');
    const [searchBySubmitdate, setSearchBySubmitdate] = useState('');
    const [searchByICD, setSearchByICD] = useState('');
    const [searchByTotalCharge, setSearchByTotalCharge] = useState('');
    const [searchByStatus, setSearchByStatus] = useState('');
    const [searchByRecievedCharge, setSearchByRecievedCharge] = useState('');
    const [searchBySubmitter, setSearchBySubmitter] = useState('');
    const [searchByClaim, setSearchByClaim] = useState('');
    const [searchByRcvdCharge, setSearchByRcvdCharge] = useState('');
    const [searchByWriteOffValue, setSearchByWriteOffValue] = useState('');
    const [searchByAdminWriteOffValue, setSearchByAdminWriteOffValue] = useState('');
    const [searchByBalance, setSearchByBalance] = useState('');
    const [searchByCheckNum, setSearchByCheckNum] = useState('');
    const [searchByCheckDate, setSearchByCheckDate] = useState('');
    const [searchByPayerRef, setSearchByPayerRef] = useState('');
    const [searchByInsuName, setSearchByInsuName] = useState('');
    const [searchByCopay, setSearchByCopay] = useState('');

    const [searchBySecRcvdCharge, setSearchBySecRcvdCharge] = useState('');
    const [searchBySecInsurance, setSearchBySecInsurance] = useState('');
    const [searchBySecCheckNum, setSearchBySecCheckNum] = useState('');
    const [searchBySecCheckDate, setSearchBySecCheckDate] = useState('');
    const [searchBySecPayerRef, setSearchBySecPayerRef] = useState('');

    const [selectedTextField, setSelectedTextField] = useState('');
    const [selectedValueField, setSelectedValueField] = useState('');
    const [selectedRecValue, setSelectedRecValue] = useState('all'); // Default value is 25
    const [totalRecords, setTotalRecords] = useState(0);
    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('DOS');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState('-1');
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState('');
    const [insOrPatFilter, setInsOrPatFilter] = useState('');
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] = useState('');
    const [selectedViewType, setSelectedViewType] = useState('0');
    const [selectedClaimService, setSelectedClaimService] = useState('0');
    const [isClaimClosed, setIsClaimClosed] = useState('false');
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState([]);
    const [filteredClaimRecCountsTableData, setFilteredClaimRecCountsTableData] = useState([]);
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState('Test Biller');

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState('');
    const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    const [billingNpiValue, setBillingNpiValue] = useState('');
    const [claimId, setClaimId] = useState('');
    const [cptCode, setCptCode] = useState('');
    const [dos, setDos] = useState('');
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);
    const [filterType, setFilterType] = useState('all');
    const [claimDOS, setClaimDOS] = useState('');
    const [isTotal, setIsTotal] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);

    const [rcvdwriteOffValue, setRcvdWriteOffValue] = useState('0');

    const [claimRecvdChargeValue, setClaimRcvdChargeValue] = useState([]);
    const [claimWriteOffValue, setClaimWriteOffvalue] = useState([]);

    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [cptChequeNumber, setcptChequeNumber] = useState([]);
    const [cptChequeDate, setCptChequeDate] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [checkDate, setCheckDate] = useState('');
    const [formatCheckDate, setFormatCheckDate] = useState('');
    const [claimPayerRefID, setClaimPayerRefID] = useState([]);
    const [claimNotes, setClaimNotes] = useState([]);

    const [checkEligibilityColor, setCheckEligibilityColor] = useState('');
    const [isLoading, setIsLoading] = useState('');
    const [isInStatus, setIsInStatus] = useState(false);

    const [payRefColor, setPayRefColor] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    const [prevFilter, setPrevFilter] = useState('');
    const [queryFilter, setQueryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] = useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] = useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isPageLoad, setisPageLoad] = useState('');
    const [deductibleAmt, setDeductible] = useState([]);
    const [patientRes, setPatientRes] = useState([]);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [copay, setcopay] = useState([]);

    const [cptSecChequeNumber, setcptsecChequeNumber] = useState([]);
    const [cptSecChequeDate, setCptSecChequeDate] = useState([]);
    const [secClaimPayerRefID, setSecClaimPayerRefID] = useState([]);
    const [secClaimRecvdCharge, setSecClaimRcvdCharge] = useState([]);

    const [searchByDeductible, setSearchByDeductible] = useState('');
    const [searchByPatientRes, setSearchByPatientRes] = useState('');
    const [searchByAdjustmentAmt, setSearchByAdjustmentAmt] = useState('');
    const [searchBySecPendingAmt, setSearchBySecPendingAmt] = useState('');
    const [adjustmentAmt, setAdjustmentAmt] = useState([]);
    const [secPendingAmt, setsecPendingAmt] = useState([]);

    const [hasFetched, setHasFetched] = useState(false);
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [searchFederal, setSearchFederal] = useState('');
    const [searchByOtherAdj, setSearchByOtherAdj] = useState('');
    const [editedValues, setEditedValues] = useState({});
    const [isDosOpen, setIsDosOpen] = useState(false);


    const rowsPerPage = 200;
    const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);

    const tableContainerRef = useRef(null);



    const loadMoreRecords = useCallback(() => {
        setVisibleRecords((prev) => {
            const next = Math.min(prev + rowsPerPage, filteredTableDetails.length);


            if (next > prev) {
                setPopupMessage(`${next} records out of ${filteredTableDetails.length} loaded`);
                setShowPopup(true);


                setTimeout(() => {
                    setShowPopup(false);
                }, 3000);
            }

            return next;
        });
    }, [filteredTableDetails.length]);




    const handleScroll = useCallback(() => {
        const isAtBottom =
            window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

        if (isAtBottom) {
            loadMoreRecords();
        }
    }, [loadMoreRecords]);




    useEffect(() => {
        setVisibleRecords(rowsPerPage);
    }, [filteredTableDetails]);




    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);




    const [totals, setTotals] = useState({
        totalUnits: 0,
        totalSubmitted: 0,
        totalReceived: 0,
        totalWriteOff: 0,
        totalAdminWriteOff: 0,
        totalBalance: 0,
    });


    const [totalsClaims, setTotalsClaims] = useState({
        totalSubmitClaim: 0,
        totalNonSubmitted: 0,
        totalSent: 0,
        totalForwarded: 0,
        totalReceivedClaim: 0,
        totalPosted: 0,
        totalPaid: 0,
        totalRejected: 0,
        totalDenied: 0
    });




    const dispatch = useDispatch();




    const userData = useSelector((state) => state.user.user);

    localStorage.setItem('userData2', JSON.stringify(userData));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    const sAuthToken = useSelector((state) => state.user.token);

    useEffect(() => {
        document.title = 'Posting Payments'

        // Set the default last 7 days' date range
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 2);

        setStartDate(sevenDaysAgo);
        setEndDate(today);



    }, []);










    useEffect(() => {
        let timerId;


        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);






    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);

            console.log("Selected start date:", formattedDate);
            setEndDate(date);
            setIsStartOpen(false)
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };






    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);
            setEndDate(today);
            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );







    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) !== null;
    };

    // Function to format dates as "yyyy-MM-dd"
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        const formattedMonth = month.padStart(2, '0');
        const formattedDay = day.padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`;
    };



    const handleHideCheckboxChange = () => {
        setIsHideChecked(!isHideChecked);

        if (isHideChecked) {
            // Reset to original dates
            setStartDate(defaultDate);
            setEndDate(defaultDate);
        } else {
            // Set FROM date to 1/1/2015 and TO date to the current date
            setStartDate('2015-01-01');
            setEndDate(defaultDate);
        }
    };




    // Api Integration of all Dropdowns

    useEffect(() => {


        const storedSelectedStatusRadioButton = localStorage.getItem('selectedStatusRadioButton');
        if (storedSelectedStatusRadioButton) {
            setSelectedStatusRadioButton(storedSelectedStatusRadioButton);
        }

        // Load stored userData from localStorage on component mount
        const storedUserData = localStorage.getItem('userData');
        var inputStruct = {

            LoggedInUserDetails: userData

        }
        console.log('LoginUserData', userData);
        var myInput = { sInputJSON: JSON.stringify(userData) };

        console.log("input of" + ClaimStatusConstants.GetClaimDropDowns, myInput);
        myInput = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetClaimDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })


            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response
                const parsedData = JSON.parse(data.d);
                const dropdownData = parsedData.Data;


                console.log("dropdownData", dropdownData);
                setSelectAllDropdown(dropdownData);
                // Populate the dropdowns with the received data
                setLocations(dropdownData.LocationDetails)

                setCMS33aData(dropdownData.CMSbox33aData);
                setCMS33bData(dropdownData.CMSbox33bData);
                setBillingNPIs(dropdownData.PracticeBillingNPIs);
                setServiceLocations(dropdownData.ServiceLocation);
                setPracticeProvider(dropdownData.PracticeProviders);
                setProviderCategory(dropdownData.ProvidersCategories);
                setSearchFilterData(dropdownData.SearchByFilters);
                setStatusRadioButton(dropdownData.StatusRadioButtons);
                setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
                setLoading(false);


            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [userData])




    //Fetch the All claim status services

    useEffect(() => {


        var inputStruct = {

            sPracticeID: userPracticeID

        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        console.log("input of GetService " + ClaimStatusConstants.GetClaimServices, myInput);
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetClaimServices, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);
                const serviceData = parsedData.Data;
                setClaimServices(parsedData)

                console.log("ClaimServiceData", claimservices);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])


    //Fetch the data of Practice Billing NPIs
    useEffect(() => {


        var inputStruct = {

            LoggedInUserDetails: userData
        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        console.log("input of GetService " + ClaimStatusConstants.GetTransactionCode, myInput);
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetPracticeBillingNPIs, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);
                const practiceData = parsedData.Data;

                setPracticeBillingNPIs(practiceData)

                console.log("practiceBillingNPIs", practiceBillingNPIs);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])










    // Fetch all Transaction Codes

    useEffect(() => {


        var inputStruct = {


        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        console.log("input of Transaction " + ClaimStatusConstants.GetTransactionCode, myInput);
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetTransactionCode, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setTransactionCodes(parsedData)

                console.log("transactionCodes", transactionCodes);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])




    const handleFilterChange = (event) => {

        setIsTextBoxDisabled(selectedSearchFilter === '');


        setSearchText('');



        setSelectedSearchFilter(event.target.value);
        if (selectedSearchFilter !== '7') {
            setBillingNPIs('');
        }

        // Default value for Updated By
        if (event.target.value === "9") {
            setInsOrPatFilter("updatedby");

        } else {
            // Handle other filter changes
            switch (event.target.value) {
                case "1":
                    setInsOrPatFilter("pat");
                    break;
                case "2":
                    setInsOrPatFilter("claimId");
                    break;
                case "3":
                    setInsOrPatFilter("ins");
                    break;
                case "4":
                    setInsOrPatFilter("verifiedby");
                    break;
                case "5":
                    setInsOrPatFilter("renderingprovider");
                    break;
                case "6":
                    setInsOrPatFilter("verifiedbyall");
                    break;
                case "7":
                    setInsOrPatFilter("billingnpi");

                    break;
                case "8":
                    setInsOrPatFilter("submittedby");
                    break;

                case "0":
                    setInsOrPatFilter(" ");
                    break;
                default:

                    break;

            }


        }
    };





    const handleSuggestionSelect = (item) => {
        setSearchText(item.label);

        setSelectedData(item.label);


        setSPatID(item.val);
        console.log("PatientID", sPatID);

        setSuggestions([]);

    };


    const handleInputKeyPress = (event) => {
        if (event.key === 'Backspace') {
            // Handle backspace key
            if (searchText === '' && suggestions.length > 0) {

                setSuggestions([]);


            } else {
                if (selectedServiceLocation === 'Insurance') {
                    fetchInsuranceCompanies(searchText.slice(0, -1));
                }

            }
        }
    }





    useEffect(() => {



        setIsTextBoxDisabled(selectedSearchFilter === '');


        setSearchText('');


    }, [selectedSearchFilter]);




    useEffect(() => {



        if (selectedSearchFilter === '1' && searchText) {
            console.log('searchText', searchText);
            fetchPatientNames();
        } else if (selectedSearchFilter === '3' && searchText) {
            fetchInsuranceCompanies();
        }



        else if (selectedSearchFilter == 0 && searchText) {
            handleAllClick();
        }


    }, [searchText])







    const fetchPatientNames = () => {


        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchText,
            SearchBy: 0,
            isFromLogin: 0
        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetAllPatientNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data



                console.log("patientLists of" + CommonAPIConstants.GetAllPatientNames, patientData);

                if (Array.isArray(patientData)) {
                    setSuggestions
                        (patientData.map((item) => ({
                            label: `${item.LastName}, ${item.FirstName}`,
                            val: item.PatientID,
                        })));

                } else {


                    setSuggestions([]);

                    setIsTextBoxDisabled(false);
                }
                console.log("PatientsuggestionsLists", suggestions);

            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };







    const fetchInsuranceCompanies = () => {


        var inputJSON = {

            SearchKey: searchText,

        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetInsuCompanyNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data);

                const InsuranceData = parsedData.Data

                console.log("InsuranceLists of" + CommonAPIConstants.GetInsuCompanyNames, InsuranceData);




                if (Array.isArray(InsuranceData)) {

                    const filteredSuggestions = InsuranceData

                        .map(item => ({
                            label: item.Insurance,
                            val: item.InsuID,
                        }))
                        .filter(item => item.label !== selectedData && item.label !== '');



                    setSuggestions(filteredSuggestions);

                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


                console.log("suggestionsLists", suggestions);
                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error('Error fetching Insurance names:', error);

            });



    };




    const isInsMounted = useRef(true);


    useEffect(() => {
        if (!isInsMounted.current) {
            if (selectedSearchFilter === 'Insurance' && searchText) {
                fetchInsuranceCompanies();
                setIsTextBoxDisabled(false);
            }
        } else {
            isInsMounted.current = false;
        }
    }, [searchText, selectedSearchFilter]);







    const handleAllClick = () => {

        handleTableDataClick();
        GetPracticeClaims();

    }



    const handleTableDataClick = (DataValidationMessage) => {
        setLoading(true);

        setSelectedAdminWriteRows([]);
        setSelectedPolicyRows([]);
        setSelectedWriteOffRows([]);
        setSelectedResubmitRows([]);

        setIsClaimChecked(true);
        setIsSubmitChecked(true);
        setIsNonSubmitChecked(true);
        setIsSentChecked(true);
        setIsForwardChecked(true);
        setIsRecvdChecked(true);
        setIsPostedChecked(true);
        setIsPaidChecked(true);
        setIsRejectedChecked(true);
        setIsDeniedChecked(true);

        const sFilterType = selectedDropdownValue;
        const MissingData = DataValidationMessage;

        if (MissingData !== "") {
            console.log("Datavalid", MissingData);
        }

        const sEmptyArr = [];

        const objInput = {
            iPracticeID: userPracticeID + "",
            sFilterText: "",
            sFromDate: startDate,
            sToDate: endDate,
            sDateFilterType: selectedDropdownValue,
            sPatientID: "0",
            sInsuranceID: "0",
            sCPT: '',
            sInsorPatFilter: '',
            sLocationID: '',
            isClosedClaims: false,
            sService: sEmptyArr,
            sCPTGroups: sEmptyArr,
            sClaimStatus: "sub"
        };





        var myInput = JSON.stringify(objInput);
        console.log("input of" + PostingpaymentsConstants.GetInsuranceClaimReconData, myInput);

        const url = `${APIConstants.BASE_URL_BILLING}${PostingpaymentsConstants.GetInsuranceClaimReconData}?sInputJSON=${myInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                const insData = JSON.parse(data);
                console.log("tableDetails", insData);

                const parsedTableData = insData.Data;
                console.log("tableData of  " + PostingpaymentsConstants.GetInsuranceClaimReconData, parsedTableData);
                setFilteredClaimRecCountsTableData(parsedTableData);

                setTimeout(() => {
                    setLoading(false);
                    setClaimRecCountsTableData(insData.Data);
                }, 100);


                setShowServiceErrorModal(false);
            })
            .catch((error) => {
                setError('API request failed');
                setLoading(false);
            });
    };






    //Bind the Main table details


    const GetPracticeClaims = (DataValidationMessage) => {
        setLoading(true);

        setSelectedAdminWriteRows([]);
        setSelectedPolicyRows([]);
        setSelectedWriteOffRows([]);
        setSelectedResubmitRows([]);

        setIsClaimChecked(true);
        setIsSubmitChecked(true);
        setIsNonSubmitChecked(true);
        setIsSentChecked(true);
        setIsForwardChecked(true);
        setIsRecvdChecked(true);
        setIsPostedChecked(true);
        setIsPaidChecked(true);
        setIsRejectedChecked(true);
        setIsDeniedChecked(true);

        const sFilterType = selectedDropdownValue;
        const MissingData = DataValidationMessage;

        if (MissingData !== "") {
            console.log("Datavalid", MissingData);
        }

        const sEmptyArr = [];

        const objInput = {
            objClaim: {
                iPracticeID: userPracticeID + "",
                sFilterText: "",
                sFromDate: startDate,
                sToDate: endDate,
                sDateFilterType: selectedDropdownValue,
                sPatientID: sPatID,
                sInsuranceID: sPatID,
                sCPT: '',
                sInsorPatFilter: insOrPatFilter,
                sLocationID: '',
                isClosedClaims: false,
                sService: sEmptyArr,
                sCPTGroups: sEmptyArr,
                sClaimStatus: "sub"
            }
        };









        var myInput = JSON.stringify(objInput);
        console.log("input of" + PostingpaymentsConstants.GetPracticeClaims, objInput);

        const url = `${APIConstants.BASE_URL_BILLING}${PostingpaymentsConstants.GetPracticeClaims}?sInputJSON=${myInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const insData = JSON.parse(data);
                console.log("tableDetails", insData);

                const parsedTableData = insData;
                console.log("tableData of  " + PostingpaymentsConstants.GetPracticeClaims, insData);
                setTableDetails(insData);

                setTimeout(() => {

                    setFilteredTableDetails(insData);
                    setLoading(false);
                }, 100);


                setShowServiceErrorModal(false);
            })
            .catch((error) => {
                setError('API request failed');
                setLoading(false);
            });
    };





    useEffect(() => {
        if (!hasFetched && startDate && endDate) {
            GetPracticeClaims();
            handleTableDataClick();
            setHasFetched(true);
        }
    }, [startDate, endDate, hasFetched]);




    const removeHtmlTags = (htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        return tempElement.textContent || tempElement.innerText;
    };





    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp.substr(6)));


    }









    // New function to update "Select All" checkbox state based on individual checkboxes
    const updateSelectAllCheckbox = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));
        const someSelected = selectedRows.length > 0 && !allSelected;

        // Update the "Select All" checkbox based on individual checkboxes
        setSelectAllChecked(allSelected);

    };

    // State for "Select All" checkbox
    const [selectAllChecked, setSelectAllChecked] = useState(false);


    // Use useEffect to update "Select All" checkbox state whenever selectedRows changes
    useEffect(() => {
        updateSelectAllCheckbox();
    }, [selectedRows]);











    const handleOpenModal = () => {


        setShowConfirmSaveModal(true);

    };







    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
    };














    const formatAppointMentDate = (dateString) => {
        const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
        const date = new Date(timestamp);

        if (isNaN(date.getTime())) {
            return '';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}/${day}/${year}`;
    };









    function getRecievedChargeClass(recievedCharge) {
        if (recievedCharge === 0) {
            return 'nonpaid-claims';
            // } else if (recievedCharge === "") {
            //   return 'paid-claims';
        } else {
            return '';
        }


    }






    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const closeFilters = () => {
        setShowFilters(false);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const formatDOSDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };


    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };




    //Saved all Claim CPT AdminWriteOffCharges

    const handleSaveClaimCPTAdminWriteOffCharges = async () => {

        console.log("selectedLocations", selectedLocation);
        console.log("selectedLOC", locations);


        console.log("userdata", userData);



        const selectedDataArray = [];

        const updatedRecords = [...filteredTableDetails];

        for (const rowIndex of selectedAdminWriteRows) {
            const item = updatedRecords[rowIndex];

            item.AdminWriteOff = item.totalcharge;
            const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

            const selectedData = {

                ClaimID: item.ClaimId,
                AdminWriteOffValue: item.AdminWriteOff,
                PracticeID: userPracticeID,
                CPTcode: item.CPTOld,
                DOS: formattedClaimDOS,
                TransactionCode: selectedTransactionCode



            }

            console.log("selectedData", selectedData);

            selectedDataArray.push(selectedData)


        }

        console.log("selectedDataarray", selectedDataArray);
        var inputStruct = {

            SelectedClaims: selectedDataArray,

            LoggedInUserDetails: userData


        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        console.log("inputRow of" + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, myInput);
        myInput = JSON.stringify(myInput);


        try {


            const response = await fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, {
                method: 'POST',


                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json'

                },

                body: myInput
            })


            if (response.ok) {
                const responseData = await response.json();


                const parsedData = JSON.parse(responseData.d);

                setUpdatedTableData(parsedData)

                console.log("SelectedRespData of" + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, responseData);

                console.log("selectedtablerows", selectedRows.length);




            } else {
                console.error('Error sending data to the API');
                setSavedRowCount(savedRowCount + selectedRows.length);

            }


            setSelectedRows([]);


        } catch (error) {
            console.error('An error occurred:', error);

        }

    }



    const handleOpenVerifiedModal = (item) => {
        setSelectedVerifiedData('');
        if (item.bIsVerified) {

            setSavingData(true);
            return;
        }




        console.log("rowdata", item);
        setClaimId(item.iClaimID);
        setCptCode(item.sCPTcode);
        const formattedClaimDOS = formatDOSDate(item.sDOSFrom);

        setDos(formattedClaimDOS)

        setShowVerifiedSaveModal(true);
        setSavingData(true);

    }





    //Saved all Verified  data
    const handleSaveVerifiedData = () => {
        setSavingData(false);
        setLoading(true)


        setSelectedVerifiedData('');

        var inputStruct =
        {
            sPracticeID: userPracticeID,
            sClaimID: claimId,
            Comments: selectedVerifiedData,
            DOS: dos,
            CPTCode: cptCode,
            LoggedInUserDetails: userData
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };


        var myInputData = JSON.stringify(myInput)
        console.log("input of" + ClaimStatusConstants.SaveVerifiedData, myInputData);


        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveVerifiedData, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);

                setSavingData(true);
                console.log("Data of " + ClaimStatusConstants.SaveVerifiedData, parsedData);

                const filteredClaims = filteredTableDetails.map((claim) => {
                    if (claim.iClaimID == claimId) {
                        return {
                            ...claim,
                            bIsVerified: true,
                            sVeriferFName: userData.FirstName,
                            sVerifierLName: userData.Lastname

                        };
                    }
                    return claim;
                });

                setTimeout(() => {
                    setLoading(false);
                    setFilteredTableDetails(filteredClaims);
                    GetPracticeClaims()

                }, 100);


                setShowVerifiedSaveModal(false);
             

            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };




    const verifiedButtonClassName = savingData ? 'saving' : 'btn-style3 mt-2';


    //Get all table data based on totalStatus Records
    const ReloadClaimsData = (filterType, isTotal, claimDOS) => {


        const filteredClaimsData = tableDetails.filter((claim) => {
            console.log('DOS:', claimDOS);
            console.log('isTotal:', isTotal);
            console.log('filterType:', filterType);
            console.log('SubmitDate:', claim.SubmitDate);
            console.log('ClaimStatusInt:', claim["ClaimStatusInt"]);

            const curDOS = formatDOSDate(claim["ClaimDOS"]);
            const submitDate = formatSubmitDate(claim.SubmitDate);
            const recvdCharge = claim.recvdCharge;
            console.log('curDOS:', curDOS);
            console.log('recvdCharge:', recvdCharge);

            //  if (claimDOS !== undefined && (!isTotal && curDOS === claimDOS)) 

            if (!isTotal && curDOS === claimDOS) {
                {
                    switch (filterType) {
                        case 'all':
                            return true;
                        case 'submit':
                            return submitDate !== "";
                        case 'nonsubmit':
                            return submitDate === "";
                        case 'sent':
                            return claim["ClaimStatusInt"] === '3';
                        case 'fwd':
                            return claim["ClaimStatusInt"] == 5;
                        case 'paid':
                            return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
                        case 'rejected':
                            return claim["ClaimStatusInt"] == 2;
                        case 'denied':
                            return claim["isDenied"] === 1;
                        case 'recvd':
                            return claim["isPaymentReceived"];
                        case 'posted':
                            return claim["isPaymentPosted"];
                        default:
                            return false;
                    }
                }
            } else {
                switch (filterType) {
                    case 'all':
                        return true;
                    case 'submit':
                        return submitDate !== "";
                    case 'nonsubmit':
                        return submitDate === "";
                    case 'sent':
                        return claim["ClaimStatusInt"] === '3';
                    case 'fwd':
                        return claim["ClaimStatusInt"] == 5;
                    case 'paid':
                        return claim["ClaimStatusInt"] == 1 && recvdCharge > 0;
                    case 'rejected':
                        return claim["ClaimStatusInt"] == 2;
                    case 'denied':
                        return claim["isDenied"] === 1;
                    case 'recvd':
                        return claim["isPaymentReceived"];
                    case 'posted':
                        return claim["isPaymentPosted"];
                    default:
                        return false;
                }
            }
        });

        setFilteredTableDetails(filteredClaimsData);
        console.log("filteredClaimsData", filteredClaimsData);
    };




    // 💰 Save Primary Received Charges
    const saveRecvdCharges = async (inputValue, item) => {
        const recvdCharges = parseFloat(inputValue) || 0;
        if (isNaN(recvdCharges)) return;

        const objClaim = {
            ClaimID: item.iClaimID,
            PracticeID: userPracticeID,
            PatientID: item.iPatientID,
            CPT: item.sCPTcode,
            PostingCharges: recvdCharges,
            DOS: formatDOSDate(item.sDOSFrom),
            UpdatedBy: userData.userID,
            PriorSec: 1,
        };

        const myInputData = JSON.stringify(JSON.stringify({ objClaim }));

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.CPTReceviedCharge,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInputData,
                }
            );

            const data = await response.json();

            if (response.ok) {
                item.sCPTReceviedCharge = recvdCharges;

                // Recalculate dependent values
                calculateAdjustment(item);
                calculateBalance(item);

                // Update UI
                setDisplayedRecords((prev) =>
                    prev.map((record) =>
                        record.iClaimID === item.iClaimID
                            ? {
                                ...record,
                                recvdCharge: recvdCharges,
                                // Adjustment: newAdjustment,
                                // claimbln: newBalance,
                            }
                            : record
                    )
                );
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("Error saving charges:", error);
        }
    };




    const saveSecClaimRecvdCharges = async (inputValue, item) => {
        try {
            const SecrecvdCharges = parseFloat(inputValue) || 0;

            // if (inputValue !== "") return

            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                PostingCharges: SecrecvdCharges,
                DOS: formatDOSDate(item.sDOSFrom),
                UpdatedBy: userData.userID,
                PriorSec: 2,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim }));

            const response = await fetch(
                APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.CPTReceviedCharge,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                }
            );

            const data = await response.json();
            console.log('outside', response);

            if (response) {

                item.sSecRecvdCharge = SecrecvdCharges;

                // Recalculate & sync with DB
                saveRecvdCharges(item.recvdCharge, {
                    ...item,
                    SecrecvdCharge: SecrecvdCharges,
                    // PatientAmount: 0,
                });
                calculateAdjustment({
                    ...item,
                    SecrecvdCharge: SecrecvdCharges,
                });
                calculateBalance({
                    ...item,
                    SecrecvdCharge: SecrecvdCharges,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred while saving secondary charges:", error);
        }
    };





    const saveAdjustmentCharges = async (adjustmentValue, item) => {
        setLoading(true);
        try {
            const AdjustAmt = parseFloat(adjustmentValue) || 0;

            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                PostingCharges: AdjustAmt,
                DOS: formatDOSDate(item.sDOSFrom),
                PriorSec: item.isPriorSecClaim,
                UpdatedBy: userData.userID,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim }));

            const res = await fetch(
                APIConstants.BASE_URL_BILLING + CommonAPIConstants.SaveAdjustmentCharges,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                }
            );
            if (res) {
                setDisplayedRecords((prev) =>
                    prev.map((record) =>
                        record.iClaimID === item.iClaimID
                            ? {
                                ...record,
                                // recvdCharge: recvdCharges,
                                Adjustment: AdjustAmt,
                                // claimbln: newBalance,
                            }
                            : record
                    )
                );
            }
        } catch (error) {
            console.error("An error occurred while saving adjustment:", error);
        } finally {
            setLoading(false);
        }
    };




    const debounceSecPendingTimeout = useRef(null);

    const SaveSecPendingCharges = async (inputText, item, eventName) => {

        const SecPendingAmt = inputText === '' ? '' : parseFloat(inputText);

        // Clear the previous timeout if it exists
        if (debounceSecPendingTimeout.current) {
            clearTimeout(debounceSecPendingTimeout.current);
        }


        debounceSecPendingTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                PostingCharges: inputText,
                DOS: formatDOSDate(item.sDOSFrom),
                PriorSec: item.isPriorSecClaim,
                UpdatedBy: userData.userID

            }



            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));


            try {
                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.SaveSecPendingCharges, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: myInput
                    });

                    const data = await response.json();



                    if (response.ok) {

                        const updatedItems = secPendingAmt.map((existingItem) =>
                            existingItem.iClaimID === item.iClaimID
                                ? { ...existingItem, SecPendingAmt: inputText }
                                : existingItem
                        );

                        item.dSecPendingAmt = inputText


                        // CalculateandShowClaimBalance(item);
                    } else {

                        console.error("API error:", data);
                    }


                }

            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);
    };


    const handleInputChange = (claimId, fieldName, value) => {
        setEditedValues(prev => ({
            ...prev,
            [claimId]: {
                ...(prev[claimId] || {}),
                [fieldName]: value
            }
        }));
    };



    const saveClaimDeductible = async (inputValue, item) => {
        try {
            const deductible = parseFloat(inputValue) || 0;

            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                PostingCharges: deductible,
                DOS: formatDOSDate(item.sDOSFrom),
                UpdatedBy: userData.userID
            }



            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimDeductible, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: myInput
            });

            const data = await response.json();

            if (response.ok) {
                item.dDeductible = deductible;
                calculateAdjustment({
                    ...item,
                    Deductible: deductible,
                });
                calculateBalance({
                    ...item,
                    Deductible: deductible,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred :", error);
        }
    };


    const savePatRes = async (inputValue, item) => {

        const patientAmount = parseFloat(inputValue) || 0;

        // if (inputValue !== "") item.PatientAmount = 0;

        const objClaim = {
            ClaimID: item.iClaimID,
            PracticeID: userPracticeID,
            PatientID: item.iPatientID,
            CPT: item.sCPTcode,
            PostingCharges: patientAmount,
            DOS: formatDOSDate(item.sDOSFrom),
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.UpdateClaimPatientResponsibility,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                }
            );

            const data = await response.json();

            if (response.ok) {
                item.dPatientAmount = patientAmount;
                calculateAdjustment({
                    ...item,
                    PatientAmount: patientAmount,
                });
                calculateBalance({
                    ...item,
                    PatientAmount: patientAmount,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };



    const debounceCopayTimeout = useRef(null);

    const SavePatientCopay = async (inputText, item, eventName) => {


        if (debounceCopayTimeout.current) {
            clearTimeout(debounceCopayTimeout.current);
        }


        debounceCopayTimeout.current = setTimeout(async () => {



            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                PostingCharges: inputText,
                DOS: formatDOSDate(item.sDOSFrom),
                PriorSec: item.isPriorSecClaim,
                UpdatedBy: userData.userID,
                CopayType: "CASH",

            }


            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            try {

                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + ClaimStatusConstants.UpdateCopayData, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${sAuthToken}`
                        },
                        body: myInput
                    });

                    const data = await response.json();
                    console.log("Response" + ClaimStatusConstants.UpdateCopayData, data);


                    if (response.ok) {

                        const updatedItems = copay.map((existingItem) =>
                            existingItem.iClaimID === item.iClaimID
                                ? { ...existingItem, dCopay: inputText }
                                : existingItem
                        );

                        item.dCopay = inputText


                    }
                }


            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);


    };


    const saveClaimWriteOff = async (inputValue, item) => {

        const writeOffAmount = parseFloat(inputValue) || 0;

        const objClaim = {
            ClaimID: item.iClaimID,
            PracticeID: userPracticeID,
            PatientID: item.iPatientID,
            CPT: item.sCPTcode,
            PostingCharges: writeOffAmount,
            DOS: formatDOSDate(item.sDOSFrom),
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateWriteoff,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                }
            );

            const data = await response.json();

            if (response.ok) {
                item.dPatWriteOff = writeOffAmount;
                calculateAdjustment({
                    ...item,
                    WriteOffAmount: writeOffAmount,
                });
                calculateBalance({
                    ...item,
                    WriteOffAmount: writeOffAmount,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred while saving write off:", error);
        }
    };



    const calculateAdjustment = (item) => {
        const total = parseFloat(item.dTotalcharge) || 0;
        const recvd = parseFloat(item.sCPTReceviedCharge) || 0;
        const secRecvd = parseFloat(item.sSecRecvdCharge) || 0;
        const writeoff = parseFloat(item.dPatWriteOff) || 0;
        const ded = parseFloat(item.dDeductible) || 0;
        const patient = parseFloat(item.dPatientAmount) || 0;
        const federal = parseFloat(item.FederalPayment) || 0;
        const adjustment = total - (recvd + secRecvd + ded + patient + writeoff + federal);
        item.dAdjustment = adjustment;
        console.log('=== Adjustment Debug Info ===');
        console.log({
            totalCharge: total,
            recvdCharge: recvd,
            secRecvd: total,
            writeOff: writeoff,
            deduct: ded,
            patient: patient,
            federal: federal,
            //   adjustment:adjustment
        });
        console.log('=============================='.adjustment);
        saveAdjustmentCharges(adjustment, item);
        return adjustment;
    };


    const calculateBalance = (item) => {
        const total = parseFloat(item.dTotalcharge) || 0;
        const recvd = parseFloat(item.sCPTReceviedCharge) || 0;
        const secRecvd = parseFloat(item.sSecRecvdCharge) || 0;
        const writeoff = parseFloat(item.dPatWriteOff) || 0;
        const ded = parseFloat(item.dDeductible) || 0;
        const patient = parseFloat(item.dPatientAmount) || 0;
        const adj = parseFloat(item.dAdjustment) || 0;
        const otherAdj = parseFloat(item.dOtherAdjustment) || 0;
        const federal = parseFloat(item.dFederalReduction) || 0;
        const adminwriteoff = parseFloat(item.dAdminWriteOffValue) || 0;
        const copay = parseFloat(item.dCopay)

        const balance = total - (recvd + secRecvd + adj + otherAdj + writeoff + adminwriteoff + copay + federal);
        item.claimbln = balance.toFixed(2);
        console.log('=== Calculating Claim Balance ===');
        console.log({
            totalCharge: total,
            recvdCharge: recvd,
            secRecvd: secRecvd, // if secRecvd is same as total, keep as total
            writeOff: writeoff,
            deduct: ded,
            adjustment: adj,
            OtherAdjustment: otherAdj,
            federal: federal,
            adminwriteoff: adminwriteoff,
            copay: copay
            //   balance:balance
        });
        console.log('=================================', balance);
        setDisplayedRecords((prev) =>
            prev.map((record) =>
                record.iClaimID === item.iClaimID
                    ? {
                        ...record,
                        claimbln: balance?.toFixed(2),
                    }
                    : record
            )
        );
    };


    const SaveOtherAdjustment = async (inputValue, item) => {

        const OtherAdjustment = parseFloat(inputValue) || 0;

        const objClaim = {
            ClaimID: item.iClaimID,
            PostingCharges: OtherAdjustment,
            PracticeID: userPracticeID,
            CPT: item.sCPTcode,
            DOS: formatDOSDate(item.sDOSFrom),
            PatientID: item.iPatientID,
            PriorSec: 1,
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.savOtherAdjustment,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                }
            );

            const data = await response.json();

            if (response.ok) {
                item.dOtherAdjustment = OtherAdjustment;
                calculateAdjustment({
                    ...item,
                    OtherAdjustment: OtherAdjustment,
                });
                calculateBalance({
                    ...item,
                    OtherAdjustment: OtherAdjustment,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };


    const SaveFederalReduction = async (inputValue, item) => {

        const federalReduction = parseFloat(inputValue) || 0;

        const objClaim = {
            ClaimID: item.iClaimID,
            PostingCharges: federalReduction,
            PracticeID: userPracticeID,
            CPT: item.sCPTcode,
            DOS: formatDOSDate(item.sDOSFrom),
            PatientID: item.iPatientID,
            PriorSec: 1,
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.SaveFedReduction,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                }
            );

            const data = await response.json();

            if (response.ok) {
                item.dFederalReduction = federalReduction;
                calculateAdjustment({
                    ...item,
                    FederalReduction: federalReduction,
                });
                calculateBalance({
                    ...item,
                    FederalReduction: federalReduction,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };






    const debounceChequeTimeout = useRef(null);



    // Saved the Claim CPT Cheque Number

    const SaveClaimCPTChequeNumber = (inputText, item, eventName) => {


        const updatedItems = Array.isArray(cptChequeNumber)
            ? cptChequeNumber.map((existingItem) =>
                existingItem === item
                    ? { ...existingItem, sChecqueNumber: inputText }
                    : existingItem
            )
            : [];

        setcptChequeNumber(updatedItems);

        item.sChecqueNumber = inputText;

        // Clear the previous timeout if it exists
        if (debounceChequeTimeout.current) {
            clearTimeout(debounceChequeTimeout.current);
        }


        debounceChequeTimeout.current = setTimeout(async () => {

            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                ChequeNumber: inputText,
                DOS: formatDOSDate(item.sDOSFrom),
                UpdatedBy: userData.userID,
                PriorSec: 1,
                IsLineItemData: 1
            }

            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            console.log("Input of " + PostingpaymentsConstants.UpdateCheckNumber, myInput);

            try {

                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckNumber, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })

                    const data = await response.json();

                    console.log("Data of " + PostingpaymentsConstants.UpdateCheckNumber, data);



                }



            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 1000);

    };




    const handleChequeDateChange = (date, index, item) => {
        const formattedDate = formatToMMDDYYYY(date);

        setCptChequeDate(prev => ({
            ...prev,
            [index]: date
        }));

        UpdateClaimChequeDate(formattedDate, item);
    };



    const handleSecChequeDateChange = (date, index, item) => {
        const formattedDate = formatToMMDDYYYY(date);

        setCptSecChequeDate(prev => ({
            ...prev,
            [index]: date
        }));

        SecUpdateClaimChequeDate(formattedDate, item);
    };


    const formatToMMDDYYYY = (date) => {
        if (!date) return '';

        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };


    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };






    const formatDateForAPI = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        const formattedMonth = (month || '').padStart(2, '0');
        const formattedDay = (day || '').padStart(2, '0');
        return `${formattedMonth}/${formattedDay}/${year}`;
    };





    const UpdateClaimChequeDate = (inputText, item) => {



        let updatedCheckDate = inputText;

        if (isValidDate(inputText)) {
            updatedCheckDate = formatDateForAPI(inputText);
            setCheckDate(updatedCheckDate);
        }

        console.log('updatedCheckDate', updatedCheckDate);


        console.log('checkDate', checkDate);


        item.sChequeDate = updatedCheckDate;

        const objClaim = {
            ClaimID: item.iClaimID,
            PracticeID: userPracticeID,
            PatientID: item.iPatientID,
            CPT: item.sCPTcode,
            ChequeDate: updatedCheckDate,
            DOS: formatDOSDate(item.sDOSFrom),
            UpdatedBy: userData.userID,
            PriorSec: 1,
            IsLineItemData: 1
        }

        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

        console.log("Input of " + PostingpaymentsConstants.UpdateCheckDate, myInput);


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckDate, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {

                //  const parsedData = JSON.parse(data.d);

                //  const cptChequeNum = parsedData.Data;

                console.log("Data of " + ClaimStatusConstants.SaveClaimChequeDate, data);

                const updatedItems = cptChequeDate.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            PaymentChequeDate: updatedCheckDate,

                        }
                        : existingItem
                );

                setCptChequeDate(updatedItems);





            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };





    const debounceRefTimeout = useRef(null);

    // Saved the Claim CPT PayerRefID
    const SaveClaimsPayerRefID = (inputText, item, eventName) => {


        const updatedItems = Array.isArray(claimPayerRefID)
            ? claimPayerRefID.map((existingItem) =>
                existingItem.iClaimID === item.iClaimID
                    ? { ...existingItem, sPayerclaimRefNumber: inputText }
                    : existingItem
            )
            : [];

        setClaimPayerRefID(updatedItems);

        item.sPayerclaimRefNumber = inputText;


        // Clear the previous timeout if it exists
        if (debounceRefTimeout.current) {
            clearTimeout(debounceRefTimeout.current);
        }


        debounceRefTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                PayerReferenceNumber: inputText,
                UpdatedBy: userData.userID,
                DOS: formatDOSDate(item.sDOSFrom),
                UpdatedBy: userData.userID,
                PriorSec: 1,


            }
            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            console.log("input of" + PostingpaymentsConstants.UpdateClaimReferencenumber, myInput);

            try {

                if (eventName.type == "blur") {

                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimReferencenumber, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })

                    const data = await response.json();

                    console.log("Data of " + PostingpaymentsConstants.UpdateClaimReferencenumber, data);
                }

            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 1000);


    };





    const debounceSecChequeTimeout = useRef(null);


    const SecSaveClaimCPTChequeNumber = (inputText, item, eventName) => {

        item.sSecCPTChequeNumber = inputText;


        if (debounceSecChequeTimeout.current) {
            clearTimeout(debounceSecChequeTimeout.current);
        }


        debounceSecChequeTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                CPT: item.sCPTcode,
                ChequeNumber: inputText,
                DOS: formatDOSDate(item.sDOSFrom),
                UpdatedBy: userData.userID,
                PriorSec: 2,
                IsLineItemData: 1

            }

            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))
            console.log("Input of " + PostingpaymentsConstants.UpdateCheckNumber, myInput);
            try {

                if (eventName.type == "blur") {

                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckNumber, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })

                    const data = await response.json();



                    console.log("Data of " + PostingpaymentsConstants.UpdateCheckNumber, data);

                    const updatedItems = cptSecChequeNumber.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                SecCPTChequeNumber: inputText,
                                isDataUpdated: true,
                            }
                            : existingItem
                    );

                    setcptsecChequeNumber(updatedItems);

                }

            }

            catch (error) {
                console.error('An error occurred:', error);
            }
        }, 1000);


    };








    const SecUpdateClaimChequeDate = (inputText, item) => {



        let updatedCheckDate = inputText;

        if (isValidDate(inputText)) {
            updatedCheckDate = formatDateForAPI(inputText);
            setCptSecChequeDate(updatedCheckDate);
        }

        console.log('updatedCheckDate', updatedCheckDate);


        console.log('checkDate', checkDate);


        item.sSecCPTChequeDate = updatedCheckDate;

        const objClaim = {
            ClaimID: item.iClaimID,
            PracticeID: userPracticeID,
            PatientID: item.iPatientID,
            CPT: item.sCPTcode,
            ChequeDate: updatedCheckDate,
            DOS: formatDOSDate(item.sDOSFrom),
            UpdatedBy: userData.userID,
            PriorSec: 2,
            IsLineItemData: 1
        }

        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))
        console.log("Input of " + PostingpaymentsConstants.UpdateCheckDate, myInput);


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckDate, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                console.log("Data of " + PostingpaymentsConstants.UpdateCheckDate, data);

                const updatedItems = cptSecChequeDate.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            PaymentChequeDate: updatedCheckDate,

                        }
                        : existingItem
                );

                setCptSecChequeDate(updatedItems);






            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };





    // Saved the Secondary Claim CPT PayerRefID
    const SecSaveClaimsPayerRefID = (inputText, item) => {

        item.sSecPayerClaimRefNumber = inputText;



        const objClaim = {

            ClaimID: item.iClaimID,
            PracticeID: userPracticeID,
            PatientID: item.iPatientID,
            PayerReferenceNumber: inputText,
            UpdatedBy: userData.userID,
            DOS: formatDOSDate(item.sDOSFrom),
            UpdatedBy: userData.userID,
            PriorSec: 2,

        }
        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

        console.log("input of" + PostingpaymentsConstants.UpdateClaimReferencenumber, myInput);

        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimReferencenumber, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                console.log("Data of " + PostingpaymentsConstants.UpdateClaimReferencenumber, data);


                const updatedItems = secClaimPayerRefID.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            sSecPayerClaimRefNumber: inputText,

                        }
                        : existingItem
                );

                setSecClaimPayerRefID(updatedItems);


            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };
















    const debounceNotesTimeout = useRef(null);

    //saved the notes message 

    const UpdateClaimNotes = (inputText, item, eventName) => {

        const updatedItems = Array.isArray(claimNotes)
            ? claimNotes.map((existingItem) =>
                existingItem === item
                    ? { ...existingItem, sPayerclaimRefNumber: inputText }
                    : existingItem
            )
            : [];

        setClaimNotes(updatedItems);

        item.sClaimNotes = inputText;

        // Clear the previous timeout if it exists
        if (debounceNotesTimeout.current) {
            clearTimeout(debounceNotesTimeout.current);
        }


        debounceNotesTimeout.current = setTimeout(async () => {

            const objClaim = {
                ClaimID: item.iClaimID,
                PracticeID: userPracticeID,
                PatientID: item.iPatientID,
                ClaimNotes: inputText,
                FirstName: item.sPatientFName,
                LastName: item.sPatientLName,
                DOS: formatDOSDate(item.sDOSFrom),
                UpdatedBy: userData.userID
            }
            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            console.log("input of" + PostingpaymentsConstants.UpdateClaimNotes, myInput);


            try {

                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimNotes, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })


                    const data = await response.json();
                    console.log("Data of " + PostingpaymentsConstants.UpdateClaimNotes, data);

                }


            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 1000);

    };







    useEffect(() => {
        const filteredData = tableDetails.filter(item => {
            return (
                (!searchByDOS || (formatDOSDate(item.sDOSFrom)?.toLowerCase().includes(searchByDOS.toLowerCase()))) &&
                (!searchByClaim || item.iClaimID?.toString().toLowerCase().includes(searchByClaim.toLowerCase())) &&
                (!searchByPatient || item.sPatientLName?.toLowerCase().includes(searchByPatient.toLowerCase())) &&
                (!searchByDOB || item.DOB?.toLowerCase().includes(searchByDOB.toLowerCase())) &&
                (!searchByInsurance || item.sInsuranceName?.toLowerCase().includes(searchByInsurance.toLowerCase())) &&
                (!searchBySecInsurance || item.sSecInsuranceName?.toLowerCase().includes(searchBySecInsurance.toLowerCase())) &&
                (!searchByCPT || item.sCPTcode?.toLowerCase().includes(searchByCPT.toLowerCase())) &&

                (!searchByTotalCharge || (searchByTotalCharge === '0'
                    ? item.dTotalcharge == 0
                    : item.dTotalcharge?.toString().toLowerCase().includes(searchByTotalCharge.toLowerCase()))) &&

                (!searchByRcvdCharge || (searchByRcvdCharge === '0'
                    ? item.sCPTReceviedCharge == 0
                    : item.sCPTReceviedCharge?.toString().toLowerCase().includes(searchByRcvdCharge.toLowerCase()))) &&

                (!searchByWriteOffValue || (searchByWriteOffValue === '0'
                    ? item.dPatWriteOff == 0
                    : item.dPatWriteOff?.toString().toLowerCase().includes(searchByWriteOffValue.toLowerCase()))) &&

                (!searchByAdminWriteOffValue || (searchByAdminWriteOffValue === '0'
                    ? item.dAdminWriteOffValue == 0
                    : item.dAdminWriteOffValue?.toString().toLowerCase().includes(searchByAdminWriteOffValue.toLowerCase()))) &&

                (!searchByDeductible || (searchByDeductible === '0'
                    ? item.dDeductible == 0
                    : item.dDeductible?.toString().toLowerCase().includes(searchByDeductible.toLowerCase()))) &&

                (!searchByPatientRes || (searchByPatientRes === '0'
                    ? item.dPatientAmount == 0
                    : item.dPatientAmount?.toString().toLowerCase().includes(searchByPatientRes.toLowerCase()))) &&

                (!searchByCopay || (searchByCopay === '0'
                    ? item.dCopay === 0
                    : item.dCopay?.toString().toLowerCase().includes(searchByCopay.toLowerCase()))) &&

                (!searchByBalance || (searchByBalance === '0'
                    ? item.dBalance === 0
                    : item.dBalance?.toString().toLowerCase().includes(searchByBalance.toLowerCase()))) &&

                (!searchByCheckNum || item.sChecqueNumber?.toString().toLowerCase().includes(searchByCheckNum.toLowerCase())) &&
                (!searchByCheckDate || formatDOSDate(item.sChequeDate)?.toLowerCase().includes(searchByCheckDate.toLowerCase())) &&

                (!searchByPayerRef || (item.sPayerclaimRefNumber?.toString().toLowerCase().startsWith(searchByPayerRef.toLowerCase()))) &&

                (!searchBySecPayerRef || (item.sSecPayerClaimRefNumber?.toString().toLowerCase().includes(searchBySecPayerRef.toLowerCase()))) &&

                (!searchByAdjustmentAmt || (searchByAdjustmentAmt === '0'
                    ? item.dAdjustment == 0
                    : item.dAdjustment?.toString().toLowerCase().includes(searchByAdjustmentAmt.toLowerCase()))) &&

                (!searchByOtherAdj || (searchByOtherAdj === '0'
                    ? item.dOtherAdjustment == 0
                    : item.dOtherAdjustment?.toString().toLowerCase().includes(searchByOtherAdj.toLowerCase()))) &&

                (!searchFederal || (searchFederal === '0'
                    ? item.dFederalReduction == 0
                    : item.dFederalReduction?.toString().toLowerCase().includes(searchFederal.toLowerCase()))) &&

                (!searchBySecPendingAmt || (searchBySecPendingAmt === '0'
                    ? item.dSecPendingAmt === 0
                    : item.dSecPendingAmt?.toString().toLowerCase().includes(searchBySecPendingAmt.toLowerCase()))) &&

                (!searchBySecCheckNum || item.sSecCPTChequeNumber?.toString().toLowerCase().includes(searchBySecCheckNum.toLowerCase())) &&
                (!searchBySecCheckDate || formatDOSDate(item.sSecCPTChequeDate)?.toLowerCase().includes(searchBySecCheckDate.toLowerCase())) &&

                (!searchByStatus || removeHtmlTags(item.ClaimStatusFlag)?.toLowerCase().includes(searchByStatus.toLowerCase())) &&
                (!searchByProvider || item.providername?.toLowerCase().includes(searchByProvider.toLowerCase())) &&
                (!searchBySubmitdate || item.dtSubmitDate?.toLowerCase().includes(searchBySubmitdate.toLowerCase()))
            );
        });

        const isSearchActive = [
            searchByDOS, searchByPatient, searchByDeductible, searchByInsurance, searchByClaim, searchByProvider, searchByAdjustmentAmt,
            searchByCPT, searchByTotalCharge, searchByRcvdCharge, searchByWriteOffValue, searchByPatientRes, searchBySubmitdate,
            searchBySecCheckNum, searchBySecCheckDate, searchBySecPayerRef, searchBySecInsurance, searchBySecPendingAmt, searchFederal, searchByOtherAdj,
            searchByBalance, searchByCheckNum, searchByCheckDate, searchByStatus, searchByPayerRef, searchByCopay, searchByAdminWriteOffValue
        ].some(Boolean);

        setFilteredTableDetails(isSearchActive ? filteredData : tableDetails);

    }, [
        searchByDOS, searchByPatient, searchByDeductible, searchByInsurance, searchByClaim, searchByProvider, searchByCPT,
        searchBySecInsurance, searchByTotalCharge, searchByRcvdCharge, searchByWriteOffValue, searchByPatientRes, searchByBalance,
        searchByCheckNum, searchByAdjustmentAmt, searchBySecPendingAmt, searchByCheckDate, searchByPayerRef, searchBySubmitdate, searchFederal, searchByOtherAdj,
        searchByStatus, searchBySecCheckNum, searchBySecCheckDate, searchBySecPayerRef, tableDetails, searchByCopay, searchByAdminWriteOffValue
    ]);







    useEffect(() => {
        const filteredData = filteredClaimRecCountsTableData.filter(item =>
            item.Insurance && typeof item.Insurance === 'string'
                ? item.Insurance.toLowerCase().includes(searchByInsuName.toLowerCase())
                : true
        );

        setClaimRecCountsTableData(filteredData);
    }, [searchByInsuName]);




    const handleInputClick = () => {
        setIsFocused(true);
    };



    const handleRowClick = (index) => {
        setActiveRow(index);
    };



    const getVerifiedBy = (name) => {
        if (!name) {
            return ''; // Return an empty string if 'name' is undefined
        }

        return name
            .split(" ")
            .map((word) => (word[0] ? word[0].toUpperCase() : ''))
            .join("");
    };



    const handleClaimCheckboxChange = () => {
        setIsClaimChecked(!isClaimChecked);

    }




    const handleClosedCheckboxChange = () => {
        setIsClaimClosed(prevState => !prevState);
        console.log("isClaimClosed", isClaimClosed);
    };



    const handleStatusClick = (InsuID, iStatus) => {
        let filteredClaims;

        if (iStatus == 0) {
            filteredClaims = tableDetails.filter(curClaim => curClaim.iInsuranceID === InsuID && curClaim.iStatus !== 1);
        } else if (iStatus == -1) {
            filteredClaims = tableDetails.filter(curClaim => curClaim.iInsuranceID === InsuID);
        } else {
            filteredClaims = tableDetails.filter(curClaim => curClaim.iInsuranceID === InsuID && curClaim.iStatus === iStatus);
        }

        setFilteredTableDetails(filteredClaims);
    };





    const handlePrint = () => {
        if (!tableRef.current) {
            console.error("Table reference is not set.");
            return;
        }

        setVisibleRecords(filteredTableDetails.length);
        const prevVisibleCount = visibleRecords;

        setTimeout(() => {
            const tableHTML = tableRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Posting Payment</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #0173b7;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 15px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 15px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A3 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 30px !important;
                      color: black;
                      
                    }
                      .input-date{
                      width: 80px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();

            printWindow.document.close();
            setTimeout(() => {
                setVisibleRecords(prevVisibleCount);
            }, 10);
        }, 10);
    };




    const tableRef = useRef('');




    const exportToExcel = () => {
        const data = filteredTableDetails.map((item, index) => {
            return {
                "#": index + 1,
                DOS: formatDOSDate(item.sDOSFrom) || "",
                "Patient Name": `${item.sPatientLName || ""}, ${item.sPatientFName || ""}`,
                "Insurance(Pri)": item.sInsuranceName || "",
                "Insurance(Sec)": item.sSecInsuranceName || "",
                "Claim ID": item.iClaimID || "",
                "CPT Code": item.sCPTcode,
                "Submit Date": formatSubmitDate(item.dtSubmitDate) || "",
                "Total Charge": item.dTotalcharge || "",
                "Charge Received(Pri)": item.sCPTReceviedCharge ?? "",
                "Charge Received(Sec)": item.sSecRecvdCharge ?? "",
                "Contractual Adjustment": item.dAdjustment ?? "",
                "Secondary Pending": editedValues[item.iClaimID]?.dSecPendingAmt ?? item.dSecPendingAmt ?? "",
                Deductible: item.dDeductible ?? "",
                "Pat Res": item.dPatientAmount ?? "",
                COPAY: item.dCopay ?? "",
                "Other Adjustment": parseFloat(item.dOtherAdjustment || 0).toFixed(2),
                "Federal Reduction": item.dFederalReduction ?? "",
                "Write-off": item.dPatWriteOff ?? "",
                "Admin Write-off": item.dAdminWriteOffValue ?? "",
                Balance: item.dBalance ?? "",
                "Cheque #(Pri)": item.sChecqueNumber || "",
                "Cheque Date(Pri)": formatDateForInput(item.sChequeDate),
                "Payer Ref #(Pri)": item.sPayerclaimRefNumber || "",
                "Cheque #(Sec)": item.sSecCPTChequeNumber || "",
                "Cheque Date(Sec)": formatDateForInput(item.sSecCPTChequeDate),
                "Payer Ref #(Sec)": item.sSecPayerClaimRefNumber || "",
                Notes: item.sClaimNotes || "",
                "Verified By": `${getVerifiedBy(item.sVeriferFName)} ${getVerifiedBy(item.sVerifierLName)}`.trim(),
                "Posted By": item.sPostedByFName || "",
            };
        });

        exportExcel(data, "PostingPayment", "PostingPayment");
    };






    const exportToPDF = () => {
        const pagename = 'PostingPayments';
        const table = tableRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const container = document.createElement('div');
        container.innerHTML = sPrintableData;
        container.querySelectorAll('.hide-on-print').forEach(el => el.remove());

        sPrintableData = container.innerHTML;

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

        console.log('Table HTML:', sPrintableData);

        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        console.log("Input of Excel", InputJSON);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {
                console.log('API response:' + FilesAPIConstants.ExportPdfFile, data);

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };





    const handleDosLinkClick = (item) => {
        const claimId = item.iClaimID;

        localStorage.setItem('selectedClaimItem', JSON.stringify(item));

        const url = `/#/transactionlogs/${claimId}`;
        window.open(url, '_blank');
    };



    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.iPatientID}/primary-insurance`;

        localStorage.setItem("PostingPatientID", item.iPatientID);

        window.open(url, '_blank');
    };




    const handleLinkClick = (item) => {
        const url = `/#/new-encounter/${item.iClaimID}?state=${encodeURIComponent(JSON.stringify(item))}`;
        window.open(url, '_blank');
    };








    return (
        <>



            <div className='main-container'>
                <div className='container-style'>
                    <div className='topnavmenu'>
                        <label className='active-label'>Posting Payment</label>
                    </div>


                    <div className='searchfilter-container' style={{ height: '60px' }}>


                        <div className='searchfilter-style'>
                            <div className='date-container'>


                                <div>


                                    <select name="select" style={{ height: '25px', height: '30px' }}
                                        value={selectedDropdownValue}
                                        onChange={(e) => setSelectedDropdownValue(e.target.value)}
                                    >

                                        <option value="DOS" >DOS</option>

                                        <option value="DOSub" >Submit Date</option>
                                    </select>

                                </div>






                                <div className="datepicker-container" style={{ marginLeft: '5px', zIndex: 10 }}>
                                    <label>From:</label>
                                    <DatePicker
                                        selected={startDate ? new Date(startDate) : null}
                                        onChange={handleStartDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        readOnly={isHideChecked}
                                        className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"

                                        calendarContainer={CalendarStartContainer}
                                        open={isStartOpen}
                                        onFocus={() => setIsStartOpen(true)}
                                        onInputClick={() => setIsStartOpen(true)}
                                        onClickOutside={() => setIsStartOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div className="datepicker-container" style={{ marginLeft: '5px', zIndex: 10 }}>
                                    <label>To:</label>
                                    <DatePicker
                                        selected={endDate ? new Date(endDate) : null}
                                        onChange={handleEndDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"
                                        popperPlacement="bottom-start"
                                        readOnly={isHideChecked}
                                        calendarContainer={CalendarContainer}
                                        open={isEndOpen}
                                        onFocus={() => setIsEndOpen(true)}
                                        onInputClick={() => setIsEndOpen(true)}
                                        onClickOutside={() => setIsEndOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>






                                <div>
                                    <label style={{ marginLeft: '25px', marginTop: '3px' }}>All</label>
                                    <input
                                        style={{ marginLeft: '10px' }}
                                        type='checkbox'
                                        checked={isHideChecked}
                                        onChange={handleHideCheckboxChange}
                                    />
                                </div>
                            </div>





                            <div className='suggestfilter-style'>
                                <div style={{ width: '200px' }}>
                                    <label>Search By:</label>
                                    <select name="select" style={{ width: '110px', height: '30px', color: 'black' }}
                                        value={selectedSearchFilter}
                                        onChange={handleFilterChange}>
                                        <option value="0"> </option>
                                        <option value="1">Patient Name</option>
                                        <option value="3">Insurance</option>

                                    </select>
                                </div>


                                <div style={{ marginLeft: '1px' }}>
                                    <input
                                        type='text'
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        onKeyDown={handleInputKeyPress}

                                        style={{ width: '100px', height: '30px' }}
                                    />
                                    <div className='autocomplete-style'>
                                        <ul className='sugglist-style' style={{ width: '200px', fontSize: '1rem' }}>
                                            {suggestions.map((suggestion, index) => (
                                                <li key={index} value={suggestion.val} onClick={() => handleSuggestionSelect(suggestion)}>
                                                    {suggestion.label}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>




                            </div>


                            <div className='searchicon-container' style={{ marginLeft: '10px', marginTop: '5px' }}>
                                <FontAwesomeIcon style={{ marginLeft: '7px', marginTop: '5px' }} onClick={(e) => handleAllClick(e)} icon={faMagnifyingGlass} />
                            </div>

                            <div className='icon-box mt-1'>
                                <FontAwesomeIcon style={{ marginTop: '8px', cursor: 'pointer' }} onClick={handlePrint} icon={faPrint} />
                                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', marginTop: '8px', cursor: 'pointer' }} onClick={exportToExcel} icon={faFileExcel} />
                                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', marginTop: '8px', cursor: 'pointer' }} onClick={exportToPDF} icon={faFilePdf} />


                            </div>


                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '10px 20px',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '5px',
                                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
                                width: 'fit-content',
                                marginTop: '5px',
                                fontSize: '1.2rem',
                                marginLeft: '20px',
                                height: '40px'
                            }}>
                                <span style={{ fontWeight: '600', color: '#333' }}>Total Records:</span>
                                <span style={{ fontWeight: '700', color: '#007bff' }}>{filteredTableDetails.length}</span>
                            </div>
                        </div>









                    </div>

                    {loading && (
                        <div className="overlay">
                            <div className="spinner-container">
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}


                    <div className='subtable-container'>
                        <table className="table table-hover table-striped table-bordered border border-white responsive mt-1 " style={{ marginLeft: '4px', width: '100%' }}>

                            <thead>

                                <tr className='align-top' >

                                    <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>

                                    <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '280px' }}>Insurance
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            value={searchByInsuName}
                                            onChange={(e) => setSearchByInsuName(e.target.value)}
                                        />
                                    </th>
                                    <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '280px' }}>All Claims

                                    </th>

                                    <th className='col col-th-style  text-white' style={{ backgroundColor: '#c9c9b2', width: '280px' }}>Submitted

                                    </th>

                                    <th className='col col-th-style  text-white' style={{ backgroundColor: '#c9c9b2', width: '280px' }}>Non-submitted

                                    </th>




                                    <th className='col col-th-style' style={{ backgroundColor: '#e9e993', color: 'black' }}>FORWARDED
                                        <FontAwesomeIcon style={{ marginLeft: '5px', fontSize: '0.9rem' }} title='Forwarded to insurance' icon={faCircleInfo} />

                                    </th>




                                    <th className='col col-th-style' style={{ backgroundColor: '#e9e993', color: 'black' }}>PAID

                                    </th>

                                    <th className='col col-th-style' style={{ backgroundColor: '#e9e993', color: 'black' }}>Non-Paid

                                        <FontAwesomeIcon style={{ marginLeft: '50px' }} icon={showDetails ? faAnglesUp : faAnglesDown} onClick={toggleDetails} />
                                    </th>





                                </tr>


                            </thead>

                            <tbody>


                                {claimRecCountsTableData && claimRecCountsTableData.map((item, index) => (
                                    (showDetails || index === claimRecCountsTableData.length - 1) && (

                                        <tr key={index}>
                                            <th>{index + 1}</th>
                                            <td style={{ backgroundColor: '#c9c9b2' }}>{item.Insurance}</td>
                                            <td>{item.AllClaims}</td>
                                            <td
                                                style={{ backgroundColor: '#c9c9b2', cursor: 'pointer', color: 'blue' }}
                                                className='rectext'
                                                onClick={() => handleStatusClick(item.InsuID, -1)}
                                            >
                                                {item.SubmittedClaims}
                                            </td>
                                            <td
                                                style={{ backgroundColor: '#c9c9b2', cursor: 'pointer' }}

                                            >
                                                {item.NonsubmittedClaims}
                                            </td>
                                            <td style={{ backgroundColor: '#c9c9b2', cursor: 'pointer', color: 'blue' }} className='rectext' onClick={() => handleStatusClick(item.InsuID, 5)}
                                            >
                                                {item.ForwardedClaims}
                                            </td>
                                            <td style={{ backgroundColor: '#c9c9b2', cursor: 'pointer', color: 'blue' }} className='rectext' onClick={() => handleStatusClick(item.InsuID, 1)}
                                            >
                                                {item.PaymentReceivedClaims}
                                            </td>
                                            <td style={{ backgroundColor: '#c9c9b2', cursor: 'pointer', color: 'blue' }} className='rectext' onClick={() => handleStatusClick(item.InsuID, 5)}
                                            >
                                                {item.PaymentNonReceivedClaims}
                                            </td>
                                        </tr>
                                    )
                                )
                                )}
                            </tbody>






                        </table>



                    </div>





                    <div className="table-container mt-1 ">
                        <table className="main_table fixed-header table-info table table-hover table-striped table-bordered border-secondary" ref={tableRef}>
                            <thead>

                                <tr className='align-top'  >

                                    <th className=' border-white col-sm col-th  text-white' style={{ backgroundColor: '#0173b7', width: '30px' }}>#</th>

                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>DOS
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByDOS}
                                            onChange={(e) => setSearchByDOS(e.target.value)}
                                        />
                                    </th>



                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7' }}>Patient Name

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            type='text'
                                            placeholder='Search'
                                            value={searchByPatient}
                                            onChange={(e) => setSearchByPatient(e.target.value)}
                                        />

                                    </th>

                                    <th className=' border-white text-white' style={{ backgroundColor: '#f1f1c4', width: '120px' }}>
                                        <a className='print-label' style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} >Insurance(Pri)</a>
                                        <br />


                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByInsurance}
                                            onChange={(e) => setSearchByInsurance(e.target.value)}
                                        />

                                    </th>

                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: 'lightyellow', width: '130px' }}>
                                        <a className='print-label' style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} >Insurance(Sec)</a>
                                        <br />


                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchBySecInsurance}
                                            onChange={(e) => setSearchBySecInsurance(e.target.value)}
                                        />

                                    </th>



                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Claim ID
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByClaim}
                                            onChange={(e) => setSearchByClaim(e.target.value)}
                                        />


                                    </th>

                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>CPT
                                        <br />

                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByCPT}
                                            onChange={(e) => setSearchByCPT(e.target.value)}
                                        />


                                    </th>




                                    <th className=' border-white col col-th-style  text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>Submit Date

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySubmitdate}
                                            onChange={(e) => setSearchBySubmitdate(e.target.value)}
                                        />
                                    </th>


                                    <th className=' border-white col col-th-style  text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>Total Charge
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByTotalCharge}
                                            onChange={(e) => setSearchByTotalCharge(e.target.value)}
                                        />
                                    </th>



                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem', width: '120px' }}>
                                        <label className='print-label' style={{ color: 'black', fontWeight: 'bold' }}>Charge Recieved(Pri)</label>

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByRcvdCharge}
                                            onChange={(e) => setSearchByRcvdCharge(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem', width: '120px' }}>
                                        <label className='print-label' style={{ color: 'black', fontWeight: 'bold' }}>Charge Recieved(Sec)</label>

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByRcvdCharge}
                                            onChange={(e) => setSearchByRcvdCharge(e.target.value)}
                                        />

                                    </th>



                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem', width: '120px' }}>
                                        <label className='print-label' style={{ color: 'black', fontWeight: 'bold' }}>Contractual Adjustment</label>

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            defaultValue={searchByAdjustmentAmt}
                                            onChange={(e) => setSearchByAdjustmentAmt(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem', width: '120px' }}>
                                        <label className='print-label' style={{ color: 'black', fontWeight: 'bold' }}>Secondary Pending</label>

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            defaultValue={searchBySecPendingAmt}
                                            onChange={(e) => setSearchBySecPendingAmt(e.target.value)}
                                        />

                                    </th>



                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Deductible
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByDeductible}
                                            onChange={(e) => setSearchByDeductible(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Pat Res
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByPatientRes}
                                            onChange={(e) => setSearchByPatientRes(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        COPAY
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByCopay}
                                            onChange={(e) => setSearchByCopay(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        Other Adjustment
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByOtherAdj}
                                            onChange={(e) => setSearchByOtherAdj(e.target.value)}

                                        />
                                    </th>
                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        Federal Reduction
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchFederal}
                                            onChange={(e) => setSearchFederal(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Write-off

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'

                                            value={searchByWriteOffValue}
                                            onChange={(e) => setSearchByWriteOffValue(e.target.value)}
                                        />

                                    </th>
                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Admin Write-off

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByAdminWriteOffValue}
                                            onChange={(e) => setSearchByAdminWriteOffValue(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Balance
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByBalance}
                                            onChange={(e) => setSearchByBalance(e.target.value)}
                                        />
                                    </th>



                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                        <label className='print-label' style={{ color: 'black', fontWeight: 'bold' }}>Cheque #(Pri)</label>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByCheckNum}
                                            onChange={(e) => setSearchByCheckNum(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                        <label className='print-label' style={{ color: 'black', fontWeight: 'bold' }}>Cheque Date(Pri)</label>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByCheckDate}
                                            onChange={(e) => setSearchByCheckDate(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                        <label style={{ color: 'black', fontWeight: 'bold' }}>Payer Ref #(Pri)</label>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByPayerRef}
                                            onChange={(e) => setSearchByPayerRef(e.target.value)}

                                        />
                                    </th>



                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                        <label style={{ color: 'black', fontWeight: 'bold' }}>Cheque #(Sec)</label>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecCheckNum}
                                            onChange={(e) => setSearchBySecCheckNum(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                        <label style={{ color: 'black', fontWeight: 'bold' }}>Cheque Date(Sec)</label>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecCheckDate}
                                            onChange={(e) => setSearchBySecCheckDate(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                        <label style={{ color: 'black', fontWeight: 'bold' }}>Payer Ref #(Sec)</label>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecPayerRef}
                                            onChange={(e) => setSearchBySecPayerRef(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: '#0173b7' }}>Notes

                                    </th>




                                    <th className=' border-white col-sm col-th text-white hide-on-print' style={{ backgroundColor: '#0173b7', width: '120px' }}>Verified By

                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByProvider}
                                            onChange={(e) => setSearchByProvider(e.target.value)}
                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white   ' style={{ backgroundColor: '#0173b7', width: '120px' }}> Posted By

                                    </th>




                                </tr>

                            </thead>



                            <tbody>


                                {filteredTableDetails.length > 0 ? (
                                    filteredTableDetails.slice(0, visibleRecords).map((item, index) => {

                                        return (
                                            <tr
                                                className={`${activeRow === index ? 'table-warning' : ''} `}
                                                key={index}
                                                onClick={() => handleRowClick(index)}

                                                style={{
                                                    backgroundColor: index % 2 === 1 ? 'lightblue' : 'inherit',
                                                }}


                                            >


                                                <td className=' border border-white' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>

                                                <td className='border border-white'>
                                                    <label className='linkspan' onClick={() => handleDosLinkClick(item)}>
                                                        {formatDOSDate(item.sDOSFrom)}
                                                    </label>
                                                </td>

                                                <td className='border border-white'>
                                                    <label className='linkspan' onClick={() => handlePatLinkClick(item)}>
                                                        {item.sPatientLName}, {item.sPatientFName}
                                                    </label>
                                                </td>


                                                <td className='border border-white'><label className='label-style'>{item.sInsuranceName}</label></td>
                                                <td className='border border-white'><label className='label-style'>{item.sSecInsuranceName}</label>


                                                </td>

                                                <td className='border border-white'>

                                                    <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                        {item.iClaimID}
                                                    </span>


                                                </td>
                                                <td className='border border-white'><label className='label-style'>{item.sCPTcode}</label></td>
                                                <td className='border border-white'><label className='label-style'>{formatSubmitDate(item.dtSubmitDate)}</label></td>
                                                <td className='border border-white'><label>{item.dTotalcharge}</label></td>



                                                <td
                                                    className={`border border-white ${item.IsPrimarySkipped ? "InsSkipped" : ""
                                                        }`}
                                                >
                                                    $
                                                    <DebouncedInput
                                                        name="sCPTReceviedCharge"
                                                        value={item.sCPTReceviedCharge ?? ""}
                                                        highlightCondition={item.sCPTReceviedCharge !== null && item.sCPTReceviedCharge !== ""}

                                                        onSave={(val) => saveRecvdCharges(val, item)}
                                                    />


                                                </td>

                                                <td className='border border-white'>
                                                    <DebouncedInput
                                                        name="sSecRecvdCharge"
                                                        value={item.sSecRecvdCharge ?? ""}
                                                        highlightCondition={!!item.sSecRecvdCharge}

                                                        onSave={(val) => saveSecClaimRecvdCharges(val, item)}
                                                    />
                                                </td>


                                                <td className='border border-white'>
                                                    $
                                                    <DebouncedInput
                                                        name="dAdjustment"
                                                        value={item.dAdjustment}
                                                        highlightCondition={item.dAdjustment !== null}
                                                        onSave={(val) => saveAdjustmentCharges(val, item)}
                                                    />
                                                </td>



                                                <td className='border border-white'>
                                                    $<input type='text' className='input' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecPendingAmt !== null ? 'lightgreen' : 'white' }}
                                                        value={
                                                            editedValues[item.iClaimID]?.dSecPendingAmt !== undefined
                                                                ? editedValues[item.iClaimID]?.dSecPendingAmt
                                                                : (item.dSecPendingAmt ?? '')
                                                        }
                                                        onChange={(e) => handleInputChange(item.iClaimID, 'dSecPendingAmt', e.target.value)}
                                                        onBlur={(e) => SaveSecPendingCharges(e.target.value, item, e)}

                                                    />
                                                </td>


                                                <td className='border border-white'>
                                                    <DebouncedInput
                                                        name="dDeductible"
                                                        value={item.dDeductible ?? ""}
                                                        highlightCondition={!!item.dDeductible}
                                                        onSave={(val) => saveClaimDeductible(val, item)}
                                                    />
                                                </td>

                                                <td className='border border-white'>
                                                    <DebouncedInput
                                                        name="dPatientAmount"
                                                        value={item.dPatientAmount ?? ""}
                                                        highlightCondition={!!item.dPatientAmount}
                                                        onSave={(val) => savePatRes(val, item)}
                                                    />
                                                </td>

                                                <td className='border border-white'>
                                                    <input type='text' className='input' style={{
                                                        width: '60px', borderRadius: '5px', borderColor: 'lightgray',
                                                        backgroundColor: item.dCopay !== null ? 'lightgray' : 'white'
                                                    }}
                                                        defaultValue={item.dCopay}
                                                        onBlur={(e) => SavePatientCopay(e.target.value, item, e)}
                                                    />
                                                </td>

                                                <td className='border border-white'>
                                                    <DebouncedInput
                                                        name="dOtherAdjustment"
                                                        value={parseFloat(item.dOtherAdjustment).toFixed(2) ?? ""}
                                                        highlightCondition={!!item.dOtherAdjustment}
                                                        onSave={(val) => SaveOtherAdjustment(val, item)}
                                                    />

                                                </td>

                                                <td className='border border-white'>
                                                    <DebouncedInput
                                                        name="dFederalReduction"
                                                        value={item.dFederalReduction || ""}
                                                        highlightCondition={!!item.dFederalReduction}
                                                        onSave={(val) => SaveFederalReduction(val, item)}
                                                    />

                                                </td>

                                                <td className='border border-white'>
                                                    <DebouncedInput
                                                        name="dPatWriteOff"
                                                        value={item.dPatWriteOff ?? ""}
                                                        highlightCondition={!!item.dPatWriteOff}
                                                        onSave={(val) => saveClaimWriteOff(val, item)}
                                                    />
                                                </td>
                                                <td className='border border-white'><label>{item.dAdminWriteOffValue}</label>  </td>

                                                <td className='border border-white'><label>{item.dBalance}</label>  </td>



                                                <td className='border border-white'>
                                                    <input className='print-label' id={`PaymentChqueNo_${index}`} type='text' style={{ width: '150px', borderRadius: '5px', backgroundColor: item.sChecqueNumber !== null ? 'lightgray' : 'white' }}
                                                        defaultValue={item.sChecqueNumber}

                                                        onBlur={(e) => SaveClaimCPTChequeNumber(e.target.value, item, e)}
                                                    />
                                                </td>

                                                <td className='border border-white'>


                                                    <DatePicker
                                                        selected={
                                                            cptChequeDate[index]
                                                                ? new Date(cptChequeDate[index])
                                                                : item.sChequeDate
                                                                    ? new Date(item.sChequeDate)
                                                                    : null
                                                        }
                                                        onChange={(date) => handleChequeDateChange(date, index, item)}
                                                        dateFormat="MM/dd/yyyy"
                                                        maxDate={new Date()}
                                                        placeholderText="MM/DD/YYYY"
                                                        className={`input-date ${item.sChequeDate !== null ? "grey-bg" : "white-bg"}`}

                                                    />
                                                </td>
                                                <td className='border border-white'>
                                                    <label className='show-on-print'>{item.sPayerclaimRefNumber}</label>
                                                    <input className='print-label hide-on-print' type='text' style={{ width: '150px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.sPayerclaimRefNumber !== null ? 'lightgray' : 'white' }}
                                                        defaultValue={item.sPayerclaimRefNumber}

                                                        onBlur={(e) => SaveClaimsPayerRefID(e.target.value, item, e)}
                                                    />
                                                </td>


                                                <td className='border border-white'>

                                                    <input className='print-label' id={`SecCPTChequeNumber${index}`} type='text' style={{ width: '150px', borderRadius: '5px', backgroundColor: item.SecCPTChequeNumber !== null ? 'lightgray' : 'white' }}
                                                        defaultValue={item.sSecCPTChequeNumber}
                                                        onBlur={(e) => SecSaveClaimCPTChequeNumber(e.target.value, item, e)}
                                                    />
                                                </td>

                                                <td className='border border-white'>

                                                    <DatePicker
                                                        selected={
                                                            cptSecChequeDate[index]
                                                                ? new Date(cptSecChequeDate[index])
                                                                : item.sSecCPTChequeDate
                                                                    ? new Date(item.sSecCPTChequeDate)
                                                                    : null
                                                        }
                                                        onChange={(date) => handleSecChequeDateChange(date, index, item)}
                                                        dateFormat="MM/dd/yyyy"
                                                        maxDate={new Date()}
                                                        placeholderText="MM/DD/YYYY"
                                                        className={`input-date ${item.sSecCPTChequeDate !== null ? "grey-bg" : "white-bg"}`}
                                                    />

                                                </td>
                                                <td className='border border-white'>
                                                    <label className='show-on-print'>{item.sSecPayerClaimRefNumber}</label>
                                                    <input className='print-label hide-on-print' id='SecPayerclaimRefNumber' type='text' style={{ width: '150px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecPayerclaimRefNumber !== null ? 'lightgray' : 'white' }}
                                                        defaultValue={item.sSecPayerClaimRefNumber}
                                                        onChange={(e) => SecSaveClaimsPayerRefID(e.target.value, item)}
                                                    />
                                                </td>


                                                <td className='border border-white'>
                                                    <textarea type='text' className='print-label' style={{ backgroundColor: item.sClaimNotes !== null ? 'lightgray' : 'white' }}
                                                        defaultValue={item.sClaimNotes}

                                                        onBlur={(e) => UpdateClaimNotes(e.target.value, item, e)}
                                                    />

                                                </td>

                                                <td className='border border-white hide-on-print' title={
                                                    item.sVeriferFName || item.dtVerifiedOn || item.sComments
                                                        ? `Verified by ${item.sVeriferFName ?? ""} on ${formatDOSDate(item.dtVerifiedOn) ?? ""}${item.sComments
                                                            ? `\n Comment : ${item.sComments}`
                                                            : ""
                                                        }`
                                                        : ""
                                                }>
                                                    <div className='d-flex'>
                                                        <label>{getVerifiedBy(item.sVeriferFName)}{getVerifiedBy(item.sVerifierLName)}</label>
                                                        <button className={item.bIsVerified == 1 ? 'saving' : 'btn-style3 mt-2'}
                                                            onClick={() => handleOpenVerifiedModal(item)} disabled={dataSaved} >Verified</button>
                                                    </div>
                                                </td>

                                                <td className='border border-white'>{item.sPostedByFName}</td>





                                            </tr>


                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>No records found</td>
                                    </tr>

                                )}




                                <tr style={{ backgroundColor: 'lightgray' }}>

                                    <td className='border-white'></td>
                                    <td className='table-bordered border border-white'> </td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white rectext'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'> </td>
                                    <td className='table-bordered border border-white'> </td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'></td>
                                    <td className='table-bordered border border-white'> </td>
                                    <td className='table-bordered border border-white'> </td>



                                </tr>






                            </tbody>



                        </table>



                        {showConfirmSaveModal && (

                            <div className='adminwrite-fax'>
                                <label>Select Transaction Code</label>
                                <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.3rem' }} onClick={handleCloseModals} icon={faXmark} />
                                <br />
                                <select style={{ width: '400px', height: '25px', marginTop: '3px' }}
                                    value={selectedTransactionCode}
                                    onChange={(e) => setSelectedTransactionCode(e.target.value)}
                                >
                                    {transactionCodes.map((item, index) => (

                                        <option value={item.TransactionCodeID}>{item.TransactionCodeDescription}</option>
                                    ))}
                                </select>

                                <br />
                                <button className='btn-style3 mt-2' onClick={handleSaveClaimCPTAdminWriteOffCharges}>Submit</button>

                            </div>
                        )}



                        {showPopup && (
                            <div style={{
                                position: 'fixed',
                                bottom: '50px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: '#333',
                                color: '#fff',
                                padding: '10px 20px',
                                borderRadius: '5px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                zIndex: 1000,
                                height: '100px',
                                width: '400px',
                                textAlign: 'center'
                            }}>
                                <label style={{ marginTop: '20px', fontSize: '1.4rem' }}>{popupMessage}</label>
                            </div>
                        )}


                        {showVerifiedSaveModal && (

                            <div className='verified-fax'>

                                <textarea placeholder='comments' style={{ width: '300px', height: '80px', borderRadius: '5px' }}
                                    value={selectedVerifiedData}
                                    onChange={(e) => setSelectedVerifiedData(e.target.value)}
                                />
                                <br />
                                <button className='btn-style3 mt-2' onClick={handleCloseModals} >Cancel</button>
                                <button className='btn-style3 mt-2' onClick={handleSaveVerifiedData}>Confirm</button>

                            </div>
                        )}

                    </div>



                    {showServiceErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one Filter from Service...</p>

                        </div>

                    )}


                    {showSelectErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one claim...</p>

                        </div>

                    )}




                    {showSuccessModal && (
                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>Selected Claim Successfully Closed</p>

                        </div>
                    )}



                </div>


            </div>




        </>
    )
}

export default PostingPayments;